export const STATE_BUSINESS_SEARCH_URLS: Record<string, string> = {
  "AL": "https://arc-sos.state.al.us/CGI/CORPNAME.MBR/INPUT",
  "AK": "https://www.commerce.alaska.gov/cbp/main/search/entities",
  "AZ": "https://ecorp.azcc.gov/EntitySearch/Index",
  "AR": "https://www.sos.arkansas.gov/corps/search_all.php",
  "CA": "https://businesssearch.sos.ca.gov/",
  "CO": "https://www.sos.state.co.us/biz/BusinessEntityCriteriaExt.do",
  "CT": "https://portal.ct.gov/SOTS/Business-Services/Business-Services/Business-Entity-Search",
  "DE": "https://icis.corp.delaware.gov/Ecorp/EntitySearch/NameSearch.aspx",
  "FL": "https://dos.myflorida.com/sunbiz/search/",
  "GA": "https://ecorp.sos.ga.gov/BusinessSearch",
  "HI": "https://hbe.ehawaii.gov/documents/search.html",
  "ID": "https://sosbiz.idaho.gov/search/business",
  "IL": "https://www.ilsos.gov/corporatellc/",
  "IN": "https://bsd.sos.in.gov/publicbusinesssearch",
  "IA": "https://sos.iowa.gov/search/business",
  "KS": "https://www.kansas.gov/bess/flow/main?execution=e1s1",
  "KY": "https://web.sos.ky.gov/ftsearch/",
  "LA": "https://coraweb.sos.la.gov/CommercialSearch/CommercialSearch.aspx",
  "ME": "https://icrs.informe.org/nei-sos-icrs/ICRS?MainPage=x",
  "MD": "https://egov.maryland.gov/BusinessExpress/EntitySearch",
  "MA": "https://corp.sec.state.ma.us/corpweb/CorpSearch/CorpSearch.aspx",
  "MI": "https://cofs.lara.state.mi.us/CorpWeb/CorpSearch/CorpSearch.aspx",
  "MN": "https://mblsportal.sos.state.mn.us/Business/Search",
  "MS": "https://corp.sos.ms.gov/corp/portal/c/page/corpBusinessIdSearch/portal.aspx",
  "MO": "https://bsd.sos.mo.gov/BusinessEntity/BESearch.aspx",
  "MT": "https://sosmt.gov/business/",
  "NE": "https://www.nebraska.gov/sos/corp/corpsearch.cgi",
  "NV": "https://esos.nv.gov/EntitySearch/OnlineEntitySearch",
  "NH": "https://quickstart.sos.nh.gov/online/BusinessInquire",
  "NJ": "https://www.njportal.com/DOR/BusinessNameSearch/Search/BusinessName",
  "NM": "https://portal.sos.state.nm.us/BFS/online/CorporationBusinessSearch",
  "NY": "https://appext20.dos.ny.gov/corp_public/corpsearch.entity_search_entry",
  "NC": "https://www.sosnc.gov/Search/Business_Registration",
  "ND": "https://firststop.sos.nd.gov/search/business",
  "OH": "https://businesssearch.ohiosos.gov/",
  "OK": "https://www.sos.ok.gov/corp/corpInquiryFind.aspx",
  "OR": "https://secure.sos.state.or.us/cbrmanager/index.action",
  "PA": "https://www.corporations.pa.gov/search/corpsearch",
  "RI": "https://business.sos.ri.gov/CorpWeb/CorpSearch/CorpSearch.aspx",
  "SC": "https://businessfilings.sc.gov/businessfiling",
  "SD": "https://sosenterprise.sd.gov/BusinessServices/Business/FilingSearch.aspx",
  "TN": "https://tnbear.tn.gov/Ecommerce/FilingSearch.aspx",
  "TX": "https://mycpa.cpa.state.tx.us/coa/",
  "UT": "https://secure.utah.gov/bes/",
  "VT": "https://bizfilings.vermont.gov/online/BusinessInquire/",
  "VA": "https://sccefile.scc.virginia.gov/Business/Index",
  "WA": "https://ccfs.sos.wa.gov/#/",
  "WV": "https://apps.wv.gov/SOS/BusinessEntitySearch/",
  "WI": "https://www.wdfi.org/apps/CorpSearch/Search.aspx",
  "WY": "https://wyobiz.wyo.gov/Business/FilingSearch.aspx"
};